import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";

import useSystemStore from "@store/useSystemStore";
import userService from "@services/user.service";
import { USER_QUERY_KEY, QUERY_CACHE_DEFAULT_EXPIRATION_MS } from "@config/query";
import { GrantProvider, GrantStatus } from "@app-types/common.type";

export function useGetUser(enabled: boolean) {
  const { isAppActive } = useSystemStore();

  const { data, error, isLoading, fetchStatus, isPlaceholderData, refetch, isFetched } = useQuery({
    enabled: enabled && isAppActive,
    queryKey: [USER_QUERY_KEY],
    queryFn: async () => {
      return await userService.getUser();
    },
    staleTime: QUERY_CACHE_DEFAULT_EXPIRATION_MS,
    retry: false,
  });

  const hasGoogleGrant = useMemo(() => {
    const hasValidGoogleGrant = data?.grants?.some(
      (grant) => grant.provider === GrantProvider.GOOGLE && grant.status === GrantStatus.VALID
    );

    return !!hasValidGoogleGrant;
  }, [data, isFetched]);

  return {
    data,
    error,
    isLoading,
    isFetched,
    fetchStatus,
    isPlaceholderData,
    refetch,
    hasGoogleGrant,
  };
}
